import { createZustandStore } from '../../../zustand';

import { ITrayState } from './type';

/**
 * This creates a local global state for Tray list selected filters and update the
 * filters
 */
export const useTrayStore = createZustandStore<ITrayState>()((set) => ({
  searchKey: '',
  updateSearchKey: (searchKey) => set({ searchKey }),
  selectedTrayFilter: null,
  updateTraySelectedFilter: (filter) => set({ selectedTrayFilter: filter }),
  searchTrayDetailsKey: '',
  updateSearchTrayDetailsKey: (searchKey) =>
    set({ searchTrayDetailsKey: searchKey }),
}));
